import React from 'react'
import { Layout } from '../layouts/Layout';
import { DownloadAplikasi } from '../componen/rilis/DownloadAplikasi'

export const DownloadAplikasiPages = () => {
  return (
    <Layout>
      <DownloadAplikasi />
    </Layout>
  )
}
